// src/components/CalledBallsDisplay.js
import React from 'react';
// Removed unused import: getLetterForBall
import { BINGO_LETTERS, NUMBERS_PER_LETTER } from '../bingoLogic';
import './CalledBallsDisplay.css';

function CalledBallsDisplay({ drawnNumbers, className }) { // Added className prop
  const renderBalls = () => {
    const columns = [];
    for (let i = 0; i < BINGO_LETTERS.length; i++) {
      const letter = BINGO_LETTERS[i];
      const startNum = i * NUMBERS_PER_LETTER + 1;
      const endNum = startNum + NUMBERS_PER_LETTER - 1;
      const ballsInColumn = [];
      for (let num = startNum; num <= endNum; num++) {
        const isCalled = drawnNumbers.has(num);
        ballsInColumn.push(
          <div
            key={num}
            className={`called-ball-cell ${isCalled ? 'called' : 'not-called'}`}
          >
            <span className="called-ball-cell-number">{num}</span>
          </div>
        );
      }
      columns.push(
        <div key={letter} className="bingo-column">
          <div className="bingo-column-header">{letter}</div>
          <div className="bingo-column-balls">{ballsInColumn}</div>
        </div>
      );
    }
    return columns;
  };

  // Use the passed className for the main container
  return (
    <div className={`called-balls-container ${className || ''}`}>
      <h2>Called Balls</h2>
      <div className="called-balls-grid">
        {renderBalls()}
      </div>
    </div>
  );
}

export default React.memo(CalledBallsDisplay);
